import { findOutboxMessagesByCriteria } from '@src/main/modules/messages/application/use-cases/find/find-outbox-messages-by-criteria.usecase';
import { OutboxMessageCriteria } from '@src/main/modules/messages/domain/message/outbox/outbox-message-criteria.interface';
import { OutboxMessageRepository } from '@src/main/modules/messages/domain/message/outbox/outbox-message.repository';
import { useQuery } from '@tanstack/react-query';

export const useOutboxMessages = (
  repository: OutboxMessageRepository | null,
  criteria: OutboxMessageCriteria,
) =>
  useQuery({
    queryKey: ['outboxMessages', criteria],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findOutboxMessagesByCriteria(repository, criteria);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });
